import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { ConfirmEventType, ConfirmationService } from 'primeng/api';
import { MsPermissionService } from 'src/app/services/ms-permission.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-ms-project',
  templateUrl: './ms-project.component.html',
  styleUrls: ['./ms-project.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']
})
export class MsProjectComponent {
  header: string = this.translate("Project");
  links: link[] = [
    {
      name: this.translate('Add Project'),
      icon: 'pi pi-plus',
      link: '/ms/project/add',
    },
    {
      name: this.translate('Vendor'),
      icon: 'pi pi-plus',
      link: '/ms/vendor',
    },
    {
      name: this.translate("Tags Management"),
      icon: 'pi pi-plus-circle',
      link: '/ms/tags-management',
      visible: this.hasPermission('MYSTERY_SHOPPER_TAGS', 'c') || this.hasPermission('MYSTERY_SHOPPER_TAGS', 'u') || this.hasPermission('MYSTERY_SHOPPER_TAGS', 'd')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
  ];

  //Pagination
  page: number = 1;
  size: number = 10;

  //Project
  projects: any[] = [];
  upProjects: any[] = [];
  onProjects: any[] = [];
  othersProjects: any[] = [];
  totalCount: number = 0;


  //API
  skelition: boolean = true;

  //Permissions
  uid: string = localStorage.getItem('uid') ?? '';
  isVendor: boolean = false;
  activeTabIndex: number = 1;
  allowedTags: string[] = this.permissionService.extractTags('MYSTERY_SHOPPER_TAGS', 'r')

  constructor(
    private dataService: DataService,
    private router: Router,
    private activatedRouter: ActivatedRoute,
    public permissionService: PermissionHandlerService,
  ) {

    const isVendorString = localStorage.getItem('isVendor')
    if (isVendorString && isVendorString != "undefined") {
      try {
        this.isVendor = JSON.parse(isVendorString);
      } catch (error) {
        console.error("Error parsing isVendorString:", error);
      }
    }

  }

  ngOnInit() {
    if (this.isVendor) {
      this.links = [];
    }
    this.projects = [];
    this.upProjects = [];
    this.onProjects = [];
    this.othersProjects = [];
    this.skelition = true;
    this.getProjects();
  }

  onTabChange(event: any) {
    this.activeTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.activatedRouter,
      queryParams: { tabIndex: this.activeTabIndex },
      queryParamsHandling: 'merge'
    });
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async getProjects() {
    try {
      let url = 'ms-project';
      if (this.isVendor) {
        let userId = localStorage.getItem('uid');
        if (userId) {
          url += ('/' + userId);
          url += `/${this.page}/${this.size}`;
        } else {
          return;
        }
      }
      else{
        url += `/${this.page}/${this.size}/${this.allowedTags.join(',')}`;
      }
      let res = await this.dataService.getData(url)
      if (res.error) {
        this.skelition = false;
        console.log(res.error);
        return;
      }
      this.projects = res.data.data;

      console.log("this.projects", this.projects)
      this.categorizeProjects();

      console.log("this.upProjects", this.upProjects)
      console.log("this.onProjects", this.onProjects)
      console.log("this.othersProjects", this.othersProjects)


      this.totalCount = res.data.totalCount
      this.skelition = false;
    } catch (e) {
      console.log(e);
    }
  }

  categorizeProjects() {
    const currentDate = new Date();
    this.projects.forEach(project => {
      const startDate = new Date(project.startDate);
      const endDate = new Date(project.endDate);
      if (currentDate < startDate) {
        this.upProjects.push(project);
      } else if (currentDate >= startDate && currentDate <= endDate) {
        this.onProjects.push(project);
      } else {
        this.othersProjects.push(project);
      }
      if (project.steps) {
        let approvedCount = 0;
        let redoCount = 0;
        let pendingCount = 0;
        let changeCount = 0;
        let isPm = MsPermissionService.checkUserPermissions(project)
        project.steps.forEach((step: { approvalStatus: any; isViewedInternal: boolean; isViewedExternal: boolean; }) => {
          let isViewed = (!!isPm || MsPermissionService.isInternalUserPM((project != undefined) ? project.internalPm : null)) ? step.isViewedInternal : step.isViewedExternal;
          switch (step.approvalStatus) {
            case "Approved":
              if (!isViewed) {
                approvedCount++;
              }
              break;
            case "Redo":
              if (!isViewed) {
                redoCount++;
              }
              break;
            case "Change":
              if (!isViewed) {
                changeCount++;
              }
              break;
            case "Pending":
              if (!isViewed) {
                pendingCount++;
              }
              break;
            default:
              break;
          }
        });
        project.statusCounts = {
          Approved: approvedCount,
          Redo: redoCount,
          Pending: pendingCount,
          Change: changeCount
        };
      }
    });
  }
}
